import {getImage} from '../utils';
import {buttonProxy} from './button.proxy';

export function heroBannerCenterAlignedProxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const title = component?.fields?.entries[0]?.fields?.title;
    const description = component?.fields?.entries[0]?.fields?.description;
    const backgroundImage = getImage(
        component?.fields?.entries[0]?.fields?.backgroundImage
    );
    const disclaimer = component?.fields?.entries[0]?.fields?.disclaimer;
    const entries = component?.fields?.entries[0];
    const buttons = entries?.fields?.actions.map((action: any) => {
        return {
            buttonboxtitle: action.fields.buttonboxtitle,
            buttonData: buttonProxy({
                ...action.fields.actions[0].fields
            })
        };
    });
    const logo = getImage(component?.fields?.entries[0]?.fields?.logo);

    return {
        componentType,
        title,
        description,
        backgroundImage,
        disclaimer,
        buttons,
        logo
    };
}
